// extracted by mini-css-extract-plugin
module.exports = {"notFound":"RouteNotFound__notFound___Trms0"};